"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.products = void 0;
exports.products = ['Web chat', 'Text chat', 'Text alerts'];
